import { useMemo } from 'react';
import { DOMAIN_ENV } from 'src/constants';

/**
 * This hooks will check the current domain env
 * Domain env is env that exist on b2xportal/.env
 */
export const useDomainEnv = () => {
  const currentDomainEnv = useMemo(() => import.meta.env.VITE_ENV, []);
  const isDomainProdEnv = useMemo(
    () => currentDomainEnv === DOMAIN_ENV.PRODUCTION,
    [currentDomainEnv],
  );

  return { isDomainProdEnv, currentDomainEnv };
};
